import { FC } from 'react';
import ConfigureGptHandler from '../Components/ExploreGpt/ConfigureGptHandler';

export const PageConfigureGpt: FC = () => {
    return <ConfigureGptHandler />;
};
